import { URLS } from 'pobble-components/dist/setup'

const celebration = [
  {
    title: 'Certificates',
    url: `${URLS.APP}/account/files/Pobble-certificate-pack.pdf`
  },
  {
    title: 'Display pack',
    url: `${URLS.APP}/account/files/Pobble-display-pack.pdf`
  },
  {
    title: 'Lanyard pack',
    url: `${URLS.APP}/account/files/Pobble-lanyard-pack.pdf`
  },
  {
    title: 'Letter pack',
    url: `${
      URLS.APP
    }/account/files/049_Letter-to-parents_Child-ABOUT-to-become-published-author.pdf`
  },
  {
    title: 'Mini Pobble Champions guide',
    url: `${URLS.APP}/account/files/Mini-Pobble-Champions.pdf`
  },
  {
    title: 'Stickers and stamps',
    url: `${URLS.APP}/account/files/Print-your-own-stickers.pdf`
  },
  {
    title: 'Writer of the week certificate',
    url: `${
      URLS.APP
    }/account/files/118_Writer-of-the-Week-pencil-certificate-A4.pptx`
  },
  {
    title: 'Website badge',
    url: `${URLS.APP}/account/files/084_pobble-web-badge-300x3001.gif`
  }
]

const classroom = [
  {
    title: 'Passcode printable',
    url: `${URLS.APP}/account/files/Passcode-printable.pdf`
  },
  {
    title: 'Pupil activity cards',
    url: `${URLS.APP}/account/files/092_Pobble-printable-activity-cards.pdf`
  },
  {
    title: 'Sandwich feedback poster',
    url: `${URLS.APP}/account/files/Pobble-Comment-sandwich-poster-A4.pdf`
  },
  {
    title: 'WAGOLL finder',
    url: `https://pobble-vault.herokuapp.com/download/file/95ba5e1d682617bbb401f43a1f6e544c`
  },
  {
    title: 'WAGOLL finder (editable)',
    url: `https://pobble-vault.herokuapp.com/download/file/6d0cf6d8995e85e2ff66cd7431d4eb33`
  },
  {
    title: 'Writing pads',
    url: `${URLS.APP}/account/files/108_Writing-pads-Year-1-6.pdf`
  }
]

export default { celebration, classroom }
